import ko from "./ko";
import en from "./en";
import ja from "./ja";

// vue-i18n messages. 기본/fallback = ko.
export default { ko, en, ja };
